import React, { useState, useEffect } from 'react'
import './forcedLabourDetailPage.css'
import redLogo from '../ui/kaleidoskop_logo_red.svg'
import backgroundImg from '../ui/backdrop_archive.png'
import ArAppAd from './ArAppAd'


const ForcedLabourDetailPage = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const person_id = searchParams.get('_id');

    const [person, SetPerson] = useState();
    const [daysOfLabour, setDaysOfLabour] = useState('???');


    const [error, setError] = useState(null);

    const [loading, setLoading] = useState(true); // Loading state

    const setTimeOfLabour = (person) => {


        if (person) {
            if (person.beschaeftigt_von_Jahr && person.beschaeftigt_bis_Jahr) {


                var startYear;
                var startMonth;
                var startDay;

                var endYear;
                var endMonth;
                var endDay;

                //setting the year

                if (Array.isArray(person.beschaeftigt_von_Jahr)) {

                    startYear = Math.min(person.beschaeftigt_von_Jahr);
                }
                else {

                    startYear = person.beschaeftigt_von_Jahr;
                }

                if (Array.isArray(person.beschaeftigt_bis_Jahr)) {
                    endYear = Math.min(person.beschaeftigt_bis_Jahr);
                }
                else {

                    endYear = person.beschaeftigt_bis_Jahr;
                }

                //seting the day
                if (person.beschaeftigt_von_Tag) {
                    if (Array.isArray(person.beschaeftigt_von_Tag)) {

                        startDay = Math.min(person.beschaeftigt_von_Tag);
                    }
                    else {
                        startDay = person.beschaeftigt_von_Tag;
                    }

                }
                else {

                    startDay = 1;
                }


                if (person.beschaeftigt_bis_Tag) {
                    if (Array.isArray(person.beschaeftigt_bis_Tag)) {

                        endDay = Math.min(person.beschaeftigt_bis_Tag);
                    }
                    else {

                        endDay = person.beschaeftigt_bis_Tag;
                    }

                }
                else {
                    endDay = 28;
                }

                //setting the month
                if (person.beschaeftigt_von_Monat) {
                    if (Array.isArray(person.beschaeftigt_von_Monat)) {

                        startMonth = Math.min(person.beschaeftigt_von_Monat);
                    }

                    else {

                        startMonth = person.beschaeftigt_von_Monat;
                    }
                }
                else {

                    startMonth = 1;
                }


                if (person.beschaeftigt_bis_Monat) {
                    if (Array.isArray(person.beschaeftigt_bis_Monat)) {

                        endMonth = Math.min(person.beschaeftigt_bis_Monat);
                    }

                    else {

                        endMonth = person.beschaeftigt_bis_Monat;
                    }
                }
                else {
                    endMonth = 12;
                }



                const startDate = new Date(startYear, startMonth - 1, startDay);
                const endDate = new Date(endYear, endMonth - 1, endDay);

                const timeDifference = Math.abs(endDate - startDate);

                const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

                return (daysDifference);





            }

            else {


                return ('???')
            }

        }



        
    }



    useEffect(
        () => {



            // Define an async function to fetch data
            const fetchData = async () => {
                try {
                    const response = await fetch(`https://aufarbeitung-kampnagel.de/api/names/${person_id}`); // Fetch data from endpoint
                    if (!response.ok) {
                        throw new Error('Failed to fetch data');
                    }
                    const result = await response.json(); // Parse JSON data
                    SetPerson(result); // Set data to state
                } catch (error) {
                    setError(error.message); // Set error message if any
                } finally {
                    setLoading(false); // Set loading to false when data is fetched
                }
            };

            fetchData();







            

            setDaysOfLabour(setTimeOfLabour(person));






        }, [person, person_id]
    )
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;







    return (




       

<>

<div>

<div id='backdropContainer'>

    <img src={backgroundImg} alt="Ein Bild mit Kaleidoskopmuster" id='Backdrop' />
</div>



<div className='detail_container'>



    <div className='info'>


        <div className='individual'>

            <div>
                <p id='name'>{person.Vorname} {person.Nachname}</p>
            </div>


            <div>
                <p id='announce'>war zwangsarbeitend für ca.</p>

            </div>
            <div id='num_days'>
                <p id='num'>{daysOfLabour}</p>
                <p id='days'>Tage</p>

            </div>





        </div>
        <div>

            <div id='details_block'>
                <div>
                    <p id='detail_name'> {person.Vorname} {person.Nachname}</p>
                </div>

                {

                    person.info.map(element =>

                        <div id='details'>
                            <p id='detail_titel'></p>
                            <p id='detail_text'>{element}</p>


                        </div>

                    )

                }



            </div>
        </div>


        <div id='logo'>
            <img src={redLogo} alt="" />
        </div>




    </div>

</div>









</div>

<ArAppAd></ArAppAd>

</>


    )
}

export default ForcedLabourDetailPage